// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1jK-R","author":"Table_author__1I_x4","authorImage":"Table_authorImage__2rpgk","unreadRow":"Table_unreadRow__3t2jq"};